export const clientId = 'aec319ae'

export const clientSsecret = 'f90ea97d862e95ee58c756855577589a'

export const base = 'https://api.jamendo.com/v3.0/'